<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';

  import { DomainsService } from '@client/services/domains';

  import CloneForm from './clone-form.svelte';

  const { addNotification } = getNotificationsContext();

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  export let show = false;
  export let domain = {};

  let formRef;
  let error = '';
  let updating = false;
  let initializing = false;

  let domainname = domain.domainname;
  let selectedDomains = [];
  let cloneOptions = {};
  let authcode = '';

  const resetModal = () => {
    show = false;
    error = '';
    formRef?.reset();
  };

  const onClone = async () => {
    const destdomains = selectedDomains.map(({ value }) => value).join('\n');

    updating = true;

    const options = Object.entries(cloneOptions).reduce((acc, [key, value]) => {
      const name =
        key === 'sftp_settings' ||
        key === 'mangoapps_settings' ||
        key === 'workday_settings' ||
        key === 'airtable_settings' ||
        key === 'bamboohr_settings'
          ? 'customdir_settings'
          : key;

      if (value) {
        acc[name] = true;
      }
      return acc;
    }, {});

    const response = await DomainsService.cloneDomain({
      cloneOptions: options,
      destdomains,
      sourcedomain: domainname,
      authcode
    });

    updating = false;

    if (response.length) {
      const message = response.shift().join(': ');

      error = $format('label.FAILURE.DOMAIN_CLONE', {
        values: { name: domainname, destination: destdomains.replace(/\n/g, ','), message }
      });

      return;
    }

    notify($format('label.SUCCESS.CLONE', { values: { type: domainname } }));

    resetModal();
  };

  $: show === false && resetModal();
</script>

<Modal bind:isOpen={show} size="lg" modalClassName="clone-modal">
  <div class="clone-domain-modal">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <h1>
        {$format('label.CLONE')} <b>{domainname}</b>
      </h1>

      <CloneForm
        bind:this={formRef}
        bind:domainname
        bind:selectedDomains
        bind:cloneOptions
        bind:authcode
        bind:initializing
        {error}
        {updating}
      />
    </div>
    <div class="footer-actions">
      <Button color="primary" disabled={!selectedDomains?.length || !domainname || !authcode} on:click={onClone}>
        {$format('label.CLONE_DOMAIN')}
      </Button>
    </div>
  </div>
</Modal>

<style lang="scss" src="./clone.scss"></style>
